import { render } from "./PwaInstallPrompt.vue?vue&type=template&id=f3ebe9f4&scoped=true"
import script from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PwaInstallPrompt.vue?vue&type=script&lang=js"

import "./PwaInstallPrompt.vue?vue&type=style&index=0&id=f3ebe9f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ebe9f4"]])

export default __exports__